













import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyCommon from "@/mixins/common";

@Component
export default class extends Mixins(MyCommon) {
  @Prop() stadiumId!: number;

  formData: any = {};

  async loadData() {
    const res = await this.$store.dispatch("stadium/todayPlay", {
      stadium_id: this.stadiumId,
    });

    // console.log(res);
    if (res && res.Data) {
      this.formData = res.Data;
    }
  }

  mounted() {
    this.loadData();
  }
}
